export interface AuthConfig {
    auth: Auth
    cache: Cache
}

export interface Auth {
    clientId: string
    authority: string
    redirectUri: string
    scopes: string[]
    postLogoutRedirectUri: string
}

export interface Cache {
    cacheLocation: string
    storeAuthStateInCookie: boolean
}

export const appConfig = {
    gatewayAPIUrl: process.env.REACT_APP_GATEWAY_API_URL,
    globalAdminRoleId: process.env.REACT_APP_GLOBAL_ADMIN_ROLE_ID,
    regionalAdminRoleId: process.env.REACT_APP_REGIONAL_ADMIN_ROLE_ID,
}

export const authSettings: AuthConfig = {
    auth: {
        clientId: process.env.REACT_APP_REG_CLIENT_ID ?? "77a9d025-3e4e-45eb-9b69-ff2218c641bb",
        authority: `https://login.microsoftonline.com/${
            process.env.REACT_APP_TENANT_DOMAIN ?? "volvogroup.onmicrosoft.com"
        }`,
        redirectUri: process.env.REACT_APP_REDIRECT_URI ?? "",
        scopes: [`api://${process.env.REACT_APP_REG_CLIENT_ID ?? "77a9d025-3e4e-45eb-9b69-ff2218c641bb"}/all`],
        postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI ?? "",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
}
